module.exports = __webpack_public_path__ + "static/media/alcohol-and-addictions-large@2x.87fc43bd.png";